import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_BASE = "http://dietdubacherla.in/diet_backend";
const BATCH_OPTIONS = ["2025-27", "2026-28", "2027-29", "2028-30"];

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [students, setStudents] = useState([]);
  const [collegeId, setCollegeId] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [studentBatch, setStudentBatch] = useState(BATCH_OPTIONS[0]);
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("student");
  const [search, setSearch] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [leaves, setLeaves] = useState([]);
  const [studentProfiles, setStudentProfiles] = useState([]);
  const [activeProfile, setActiveProfile] = useState(null);
  const [galleryFile, setGalleryFile] = useState(null);
  const [galleryTitle, setGalleryTitle] = useState("");
  const [gallery, setGallery] = useState([]);
  const [expandedGallery, setExpandedGallery] = useState(false);
  const [homeSliderFile, setHomeSliderFile] = useState(null);
  const [homeSliderTitle, setHomeSliderTitle] = useState("");
  const [homeSlides, setHomeSlides] = useState([]);
  const [pdfTitle, setPdfTitle] = useState("");
  const [pdfCategory, setPdfCategory] = useState("students");
  const [downloadType, setDownloadType] = useState("file");
  const [downloadUrl, setDownloadUrl] = useState("");
  const [downloadText, setDownloadText] = useState("");
  const [pdfFile, setPdfFile] = useState(null);
  const [downloads, setDownloads] = useState([]);
  const [timetableTitle, setTimetableTitle] = useState("");
  const [timetableAudience, setTimetableAudience] = useState("all");
  const [timetableFile, setTimetableFile] = useState(null);
  const [timetables, setTimetables] = useState([]);
  const [activeTab, setActiveTab] = useState("dashboard");
  const [notifications, setNotifications] = useState([]);
  const [faculty, setFaculty] = useState([]);
  const [leaveSearch, setLeaveSearch] = useState("");
  const [profileSearch, setProfileSearch] = useState("")

  const [facultyName, setFacultyName] =
    useState("");

  const [facultyDesignation,
  setFacultyDesignation] =
    useState("");

  const [facultyQualification,
  setFacultyQualification] =
    useState("");

  const [facultyImage,
  setFacultyImage] =
    useState(null);

  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);

  useEffect(() => {
    fetchStudents();
    fetchLeaves();
    fetchStudentProfiles();
    fetchNotifications();
    fetchGallery();
    fetchHomeSlides();
    fetchDownloads();
    fetchTimetables();
    fetchFaculty();
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const pendingLeaves = leaves.filter((leave) => leave.status === "Pending").length;
  const approvedLeaves = leaves.filter((leave) => leave.status === "Approved").length;

  const filteredStudents = useMemo(() => {
    const keyword = search.toLowerCase();

    return students.filter(
      (student) =>
        student.college_id?.toLowerCase().includes(keyword) ||
        student.name?.toLowerCase().includes(keyword) ||
        student.email?.toLowerCase().includes(keyword) ||
        student.batch?.toLowerCase().includes(keyword) ||
        student.role?.toLowerCase().includes(keyword)
    );
  }, [search, students]);

  const filteredLeaves = useMemo(() => {
    const keyword = leaveSearch.toLowerCase().trim();
    if (!keyword) return leaves;

    return leaves.filter((leave) =>
      [leave.college_id, leave.name,  leave.status, leave.reason, leave.from_date, leave.to_date]
        .filter(Boolean)
        .some((value) => value.toString().toLowerCase().includes(keyword))
    );
  }, [leaveSearch, leaves]);

  const filteredStudentProfiles = useMemo(() => {
    const keyword = profileSearch.toLowerCase().trim();
    if (!keyword) return studentProfiles;

    return studentProfiles.filter((profile) =>
      Object.values(profile)
        .filter(Boolean)
        .some((value) => value.toString().toLowerCase().includes(keyword))
    );
  }, [profileSearch, studentProfiles]);

    const fetchFaculty = () => {
    axios
      .get(
        "http://dietdubacherla.in/diet_backend/get_faculty.php"
      )
      .then((res) => {
        setFaculty(res.data);
      });
  };
    const uploadFaculty = () => {
    const formData = new FormData();

    formData.append(
      "name",
      facultyName
    );

    formData.append(
      "designation",
      facultyDesignation
    );

    formData.append(
      "qualification",
      facultyQualification
    );

    formData.append(
      "image",
      facultyImage
    );

    axios
      .post(
        "http://dietdubacherla.in/diet_backend/upload_faculty.php",
        formData
      )
      .then((res) => {
        if(res.data.status==="success"){
          alert("Faculty Added");

          setFacultyName("");
          setFacultyDesignation("");
          setFacultyQualification("");
          setFacultyImage(null);

          fetchFaculty();
        }
      });
  };

  const deleteFaculty = (id) => {

  if(
    !window.confirm(
      "Delete faculty?"
    )
  ) return;

  axios
    .post(
      "http://dietdubacherla.in/diet_backend/delete_faculty.php",
      { id }
    )
    .then(() => {
      fetchFaculty();
    });
};




  const fetchStudents = () => {
    axios
      .get(`${API_BASE}/get_students.php`)
      .then((res) => setStudents(res.data))
      .catch((err) => console.log(err));
  };

  const fetchLeaves = () => {
    axios
      .get(`${API_BASE}/get_leaves.php`)
      .then((res) => setLeaves(Array.isArray(res.data) ? res.data : []))
      .catch((err) => console.log(err));
  };
  const fetchStudentProfiles = () => {
    axios
      .post(`${API_BASE}/student_profile.php`, { action: "list" })
      .then((res) => setStudentProfiles(Array.isArray(res.data?.profiles) ? res.data.profiles : []))
      .catch((err) => console.log(err));
  };


  const fetchDownloads = () => {
    axios
      .get(`${API_BASE}/get_downloads.php`)
      .then((res) => setDownloads(Array.isArray(res.data) ? res.data : []))
      .catch((err) => console.log(err));
  };

  const fetchTimetables = () => {
    axios
      .get(`${API_BASE}/get_timetables.php`)
      .then((res) => setTimetables(Array.isArray(res.data) ? res.data : []))
      .catch((err) => console.log(err));
  };

  const fetchNotifications = () => {
    axios
      .get(`${API_BASE}/get_notifications.php`)
      .then((res) => setNotifications(res.data))
      .catch((err) => console.log(err));
  };

  const fetchGallery = () => {
    axios
      .get(`${API_BASE}/get_gallery.php`)
      .then((res) => setGallery(res.data))
      .catch((err) => console.log(err));
  };

  const fetchHomeSlides = () => {
    axios
      .get(`${API_BASE}/get_home_slider.php`)
      .then((res) => setHomeSlides(Array.isArray(res.data) ? res.data : []))
      .catch((err) => console.log(err));
  };

  const logout = () => {
    localStorage.removeItem("user");
    navigate("/");
  };

  const addUser = () => {
    const trimmedCollegeId = collegeId.trim();
    const trimmedName = name.trim();
    const trimmedEmail = email.trim();
    const selectedBatch = studentBatch.trim();
    const trimmedPassword = password.trim();
    const selectedRole = role.trim();

    if (!trimmedCollegeId || !trimmedName || !trimmedEmail || !trimmedPassword || !selectedRole) {
      alert("Please fill all user fields before adding.");
      return;
    }

    if (selectedRole === "student" && !selectedBatch) {
      alert("Please select a batch for the student.");
      return;
    }

    axios
      .post(`${API_BASE}/add_user.php`, {
        college_id: trimmedCollegeId,
        name: trimmedName,
        email: trimmedEmail,
        batch: selectedRole === "student" ? selectedBatch : "",
        password: trimmedPassword,
        role: selectedRole,
      })
      .then((res) => {
        if (res.data.status === "success") {
          alert("User Added");
          setCollegeId("");
          setName("");
          setEmail("");
          setStudentBatch(BATCH_OPTIONS[0]);
          setPassword("");
          setRole("student");
          fetchStudents();
        } else {
          alert(res.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
        alert("Server error");
      });
  };

  const deleteStudent = (id) => {
    if (!window.confirm("Delete this student?")) return;

    axios
      .post(`${API_BASE}/delete_student.php`, { id })
      .then(() => fetchStudents())
      .catch((err) => console.log(err));
  };

  const editStudent = (student) => {
    const newName = prompt("Enter Name", student.name);
    if (!newName) return;

    const newEmail = prompt("Enter Email", student.email);
    if (!newEmail) return;

    const newBatch = student.role === "student" ? prompt("Enter Batch", student.batch || BATCH_OPTIONS[0]) : "";
    if (student.role === "student" && !newBatch) return;

    axios
      .post(`${API_BASE}/update_student.php`, {
        id: student.id,
        name: newName,
        email: newEmail,
        batch: newBatch,
      })
      .then((res) => {
        if (res.data.status === "success") {
          alert("Student Updated");
          fetchStudents();
        }
      })
      .catch((err) => console.log(err));
  };

  const addNotification = () => {
    const trimmedTitle = title.trim();
    const trimmedMessage = message.trim();

    if (!trimmedTitle || !trimmedMessage) {
      alert("Please enter both title and message before posting.");
      return;
    }

    axios
      .post(`${API_BASE}/add_notification.php`, {
        title: trimmedTitle,
        message: trimmedMessage,
      })
      .then((res) => {
        if (res.data.status === "success") {
          alert("Notification Posted");
          setTitle("");
          setMessage("");
          fetchNotifications();
        }
      })
      .catch((err) => console.log(err));
  };

  const uploadGallery = () => {
    if (!galleryFile) {
      alert("Select an image first");
      return;
    }

    const formData = new FormData();
    formData.append("title", galleryTitle);
    formData.append("file", galleryFile);

    axios
      .post(`${API_BASE}/upload_gallery.php`, formData)
      .then(() => {
        alert("Uploaded");
        setGalleryFile(null);
        setGalleryTitle("");
        fetchGallery();
      })
      .catch((err) => console.log(err));
  };

  const deleteGallery = (id) => {
    if (!window.confirm("Delete this image?")) return;

    const formData = new FormData();
    formData.append("id", id);

    axios
      .post(`${API_BASE}/delete_gallery.php`, formData)
      .then(() => fetchGallery())
      .catch((err) => console.log(err));
  };

  const uploadHomeSlide = () => {
    const trimmedTitle = homeSliderTitle.trim();

    if (!trimmedTitle) return alert("Enter slide title");
    if (!homeSliderFile) return alert("Select a home slider image");

    const formData = new FormData();
    formData.append("title", trimmedTitle);
    formData.append("file", homeSliderFile);

    axios
      .post(`${API_BASE}/upload_home_slider.php`, formData)
      .then((res) => {
        if (res.data.status === "success") {
          alert("Home slider image uploaded");
          setHomeSliderTitle("");
          setHomeSliderFile(null);
          fetchHomeSlides();
        } else {
          alert(res.data.message || "Upload failed");
        }
      })
      .catch((err) => console.log(err));
  };

  const deleteHomeSlide = (id) => {
    if (!window.confirm("Delete this home slider image?")) return;

    const formData = new FormData();
    formData.append("id", id);

    axios
      .post(`${API_BASE}/delete_home_slider.php`, formData)
      .then(() => fetchHomeSlides())
      .catch((err) => console.log(err));
  };

  const uploadPDF = () => {
    const trimmedPdfTitle = pdfTitle.trim();
    const trimmedDownloadUrl = downloadUrl.trim();
    const trimmedDownloadText = downloadText.trim();

    if (!trimmedPdfTitle) return alert("Enter title");
    if (downloadType === "file" && !pdfFile) return alert("Select file");
    if (downloadType === "link" && !trimmedDownloadUrl) return alert("Enter link");
    if (downloadType === "text" && !trimmedDownloadText) return alert("Enter content or news text");

    const formData = new FormData();
    formData.append("title", trimmedPdfTitle);
    formData.append("category", pdfCategory);
    formData.append("source_type", downloadType);
    formData.append("content_url", trimmedDownloadUrl);
    formData.append("content_text", trimmedDownloadText);
    if (pdfFile) formData.append("file", pdfFile);

    axios
      .post(`${API_BASE}/upload_download.php`, formData)
      .then((res) => {
        if (res.data.status === "success") {
          alert("Uploaded Successfully");
          setPdfTitle("");
          setPdfCategory("students");
          setDownloadType("file");
          setDownloadUrl("");
          setDownloadText("");
          setPdfFile(null);
          fetchDownloads();
        } else {
          alert(res.data.message);
        }
      })
      .catch((err) => console.log(err));
  };


  const deleteDownload = (id) => {
    if (!window.confirm("Delete this download?")) return;

    axios
      .post(`${API_BASE}/delete_download.php`, { id })
      .then((res) => {
        if (res.data?.status === "success") fetchDownloads();
        else alert(res.data?.message || "Unable to delete download");
      })
      .catch((err) => console.log(err));
  };

  const uploadTimetable = () => {
    const trimmedTitle = timetableTitle.trim();

    if (!trimmedTitle) return alert("Enter timetable title");
    if (!timetableFile) return alert("Select timetable file");

    const formData = new FormData();
    formData.append("title", trimmedTitle);
    formData.append("audience", timetableAudience);
    formData.append("file", timetableFile);

    axios
      .post(`${API_BASE}/upload_timetable.php`, formData)
      .then((res) => {
        if (res.data?.status === "success") {
          alert("Timetable uploaded");
          setTimetableTitle("");
          setTimetableAudience("all");
          setTimetableFile(null);
          fetchTimetables();
        } else {
          alert(res.data?.message || "Unable to upload timetable");
        }
      })
      .catch((err) => console.log(err));
  };

  const deleteTimetable = (id) => {
    if (!window.confirm("Delete this timetable?")) return;

    axios
      .post(`${API_BASE}/delete_timetable.php`, { id })
      .then((res) => {
        if (res.data?.status === "success") fetchTimetables();
        else alert(res.data?.message || "Unable to delete timetable");
      })
      .catch((err) => console.log(err));
  };

  const updateLeaveStatus = (id, status) => {
    axios
      .post(`${API_BASE}/update_leave_status.php`, { id, status })
      .then((res) => {
        if (res.data?.status === "error") {
          alert(res.data.message || "Unable to update leave status");
          return;
        }
        fetchLeaves();
      })
      .catch((err) => console.log(err));
  };

  const navItems = [
    { id: "dashboard", label: "Dashboard", icon: "DB" },
    { id: "users", label: "Users", icon: "US" },
    { id: "studentProfiles", label: "Student Profiles", icon: "SP" },
    { id: "facultyManagement", label: "Faculty Management", icon: "FM" },
    { id: "notifications", label: "Notifications", icon: "NT" },
    { id: "homeSlider", label: "Home Slider", icon: "HS" },
    { id: "gallery", label: "Gallery", icon: "GL" },
    { id: "downloads", label: "Downloads", icon: "DL" },
    { id: "timetable", label: "Timetable", icon: "TT" },
    { id: "leaves", label: "Leave Requests", icon: "LV" },
  ];

  const pageTitles = {
    dashboard: "Dashboard",
    users: "User Management",
    studentProfiles: "Student Profiles",
    facultyManagement: "Faculty Management",
    notifications: "Notifications",
    homeSlider: "Home Slider",
    gallery: "Gallery Management",
    downloads: "Downloads",
    timetable: "Timetable",
    leaves: "Leave Requests",
  };

  const pageDescriptions = {
    dashboard: "Overview of users, leave requests and content activity.",
    users: "Create accounts, search records and manage student details.",
    studentProfiles: "View student profile details submitted from the student dashboard.",
    facultyManagement: "Manage Faculty",
    notifications: "Post official updates for users.",
    homeSlider: "Upload and manage images shown in the homepage slider.",
    gallery: "Upload, review and remove gallery images.",
    downloads: "Upload and manage public download PDFs.",
    timetable: "Upload timetable files for students and faculty.",
    leaves: "Approve or reject submitted leave applications.",
  };

  return (
    <div style={{ ...styles.appShell, ...(isMobile ? styles.appShellMobile : {}) }}>
      <aside style={{ ...styles.sidebar, ...(isMobile ? styles.sidebarMobile : {}) }}>
        <div style={{ ...styles.brandBlock, ...(isMobile ? styles.brandBlockMobile : {}) }}>
          <div style={styles.brandMark}>D</div>
          <div>
            <h2 style={styles.brandTitle}>DIET ERP</h2>
            <p style={styles.brandSubtext}>Admin Portal</p>
          </div>
        </div>

        <nav style={{ ...styles.navList, ...(isMobile ? styles.navListMobile : {}) }}>
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              style={{
                ...styles.navButton,
                ...(isMobile ? styles.navButtonMobile : {}),
                ...(activeTab === item.id ? styles.navButtonActive : {}),
              }}
            >
              <span style={styles.navIcon}>{item.icon}</span>
              <span style={styles.navLabel}>{item.label}</span>
            </button>
          ))}
        </nav>

        {/* <button onClick={logout} style={{ ...styles.logoutButton, ...(isMobile ? styles.logoutButtonMobile : {}) }}>
          Logout
        </button> */}
      </aside>

      <main style={{ ...styles.mainPanel, ...(isMobile ? styles.mainPanelMobile : {}) }}>
        <header style={{ ...styles.topBar, ...(isMobile ? styles.topBarMobile : {}) }}>
          <div>
            <p style={styles.eyebrow}>Administration</p>
            <h1 style={{ ...styles.pageTitle, ...(isMobile ? styles.pageTitleMobile : {}) }}>
              {pageTitles[activeTab]}
            </h1>
            <p style={styles.pageDescription}>{pageDescriptions[activeTab]}</p>
          </div>
          <button onClick={logout} style={{ ...styles.secondaryLogout, ...(isMobile ? styles.hideOnMobile : {}) }}>
            Sign out
          </button>
        </header>

        {activeTab === "dashboard" && (
          <>
            <section style={{ ...styles.statsGrid, ...(isMobile ? styles.statsGridMobile : {}) }}>
              <StatCard label="Total Users" value={students.length} tone="#7c2d12" />
              <StatCard label="Pending Leaves" value={pendingLeaves} tone="#b45309" />
              <StatCard label="Approved Leaves" value={approvedLeaves} tone="#15803d" />
              <StatCard label="Notifications" value={notifications.length} tone="#1d4ed8" />
            </section>

            <section style={{ ...styles.twoColumn, ...(isMobile ? styles.singleColumnGrid : {}) }}>
              <div style={styles.card}>
                <div style={styles.cardHeader}>
                  <h2 style={styles.cardTitle}>Recent Leave Requests</h2>
                  <button style={styles.textButton} onClick={() => setActiveTab("leaves")}>
                    View all
                  </button>
                </div>
                <DataTable
                  columns={["Student ID", "Days", "Status"]}
                  rows={leaves.slice(0, 5).map((leave) => [
                    leave.college_id,
                    leave.leave_days || 1,
                    <StatusPill status={leave.status} />,
                  ])}
                  emptyText="No matching leave requests found."
                />
              </div>

              <div style={styles.card}>
                <div style={styles.cardHeader}>
                  <h2 style={styles.cardTitle}>Quick Actions</h2>
                </div>
                <div style={styles.quickActions}>
                  <button style={styles.quickActionButton} onClick={() => setActiveTab("users")}>
                    Add User
                  </button>
                  <button style={styles.quickActionButton} onClick={() => setActiveTab("notifications")}>
                    Post Notification
                  </button>
                  <button style={styles.quickActionButton} onClick={() => setActiveTab("downloads")}>
                    Upload PDF
                  </button>
                  <button style={styles.quickActionButton} onClick={() => setActiveTab("homeSlider")}>
                    Update Home Slider
                  </button>
                  <button style={styles.quickActionButton} onClick={() => setActiveTab("gallery")}>
                    Upload Gallery Image
                  </button>
                </div>
              </div>
            </section>
          </>
        )}

        {activeTab === "users" && (
          <section style={{ ...styles.moduleGrid, ...(isMobile ? styles.moduleGridMobile : {}) }}>
            <div style={styles.card}>
              <h2 style={styles.cardTitle}>Add User</h2>
              <div style={styles.formGrid}>
                <input
                  placeholder="College ID"
                  value={collegeId}
                  onChange={(e) => setCollegeId(e.target.value)}
                  style={styles.input}
                />
                <input
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  style={styles.input}
                />
                <input
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={styles.input}
                />
                <input
                  placeholder="Password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={styles.input}
                />
                <select value={role} onChange={(e) => setRole(e.target.value)} style={styles.input}>
                  <option value="student">Student</option>
                  <option value="faculty">Faculty</option>
                  <option value="admin">Admin</option>
                </select>
                {role === "student" && (
                  <select value={studentBatch} onChange={(e) => setStudentBatch(e.target.value)} style={styles.input}>
                    {BATCH_OPTIONS.map((batch) => (
                      <option key={batch} value={batch}>{batch}</option>
                    ))}
                  </select>
                )}
              </div>
              <button onClick={addUser} style={styles.primaryButton}>
                Add User
              </button>
            </div>

            <div style={styles.cardWide}>
              <div style={{ ...styles.cardHeader, ...(isMobile ? styles.cardHeaderMobile : {}) }}>
                <h2 style={styles.cardTitle}>User Records</h2>
                <input
                  type="text"
                  placeholder="Search by college ID, name, email, batch or role"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={styles.searchInput}
                />
              </div>
              <div style={styles.tableWrap}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>College ID</th>
                      <th style={styles.th}>Name</th>
                      <th style={styles.th}>Email</th>
                      <th style={styles.th}>Batch</th>
                      <th style={styles.th}>Role</th>
                      <th style={styles.th}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredStudents.map((student) => (
                      <tr key={student.id}>
                        <td style={styles.td}>{student.college_id}</td>
                        <td style={styles.td}>{student.name}</td>
                        <td style={styles.td}>{student.email}</td>
                        <td style={styles.td}>{student.role === "student" ? student.batch || "-" : "-"}</td>
                        <td style={styles.td}>
                          <span style={styles.rolePill}>{student.role}</span>
                        </td>
                        <td style={styles.td}>
                          <button onClick={() => editStudent(student)} style={styles.editBtn}>
                            Edit
                          </button>
                          {student.role === "student" && (
                            <button onClick={() => {
                              const profile = studentProfiles.find((item) => item.deecet_id === student.college_id);
                              if (profile) setActiveProfile(profile);
                              else alert("Profile not submitted yet.");
                            }} style={styles.editBtn}>
                              Profile
                            </button>
                          )}
                          <button onClick={() => deleteStudent(student.id)} style={styles.deleteBtn}>
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                    {filteredStudents.length === 0 && (
                      <tr>
                        <td colSpan="6" style={styles.emptyCell}>
                          No users found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        )}


        {activeTab === "studentProfiles" && (
          <section style={styles.card}>
            <div style={{ ...styles.cardHeader, ...(isMobile ? styles.cardHeaderMobile : {}) }}>
              <div>
                <h2 style={styles.cardTitle}>Student Profiles</h2>
                <p style={styles.cardSubtext}>{filteredStudentProfiles.length} of {studentProfiles.length} submitted profiles</p>
              </div>
              <button onClick={fetchStudentProfiles} style={styles.textButton}>Refresh</button>
            </div>
            <input
              type="text"
              placeholder="Search profiles by ID, name, batch, medium, village, district..."
              value={profileSearch}
              onChange={(e) => setProfileSearch(e.target.value)}
              style={styles.searchInput}
            />
            <div style={styles.tableWrap}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Photo</th>
                    <th style={styles.th}>DEECET ID</th>
                    <th style={styles.th}>Name</th>
                    <th style={styles.th}>Admission No.</th>
                    <th style={styles.th}>Batch</th>
                    <th style={styles.th}>Medium</th>
                    <th style={styles.th}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredStudentProfiles.map((profile) => (
                    <tr key={profile.deecet_id}>
                      <td style={styles.td}>
                        {profile.photo_url ? <img src={profile.photo_url} alt={profile.name} style={styles.profileThumb} /> : "-"}
                      </td>
                      <td style={styles.td}>{profile.deecet_id}</td>
                      <td style={styles.td}>{profile.surname} {profile.name}</td>
                      <td style={styles.td}>{profile.admission_no}</td>
                      <td style={styles.td}>{profile.batch}</td>
                      <td style={styles.td}>{profile.medium}</td>
                      <td style={styles.td}>
                        <button style={styles.editBtn} onClick={() => setActiveProfile(profile)}>View</button>
                      </td>
                    </tr>
                  ))}
                  {filteredStudentProfiles.length === 0 && (
                    <tr>
                      <td colSpan="7" style={styles.emptyCell}>No matching student profiles found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </section>
        )}
        {activeTab === "notifications" && (
          <section style={{ ...styles.twoColumn, ...(isMobile ? styles.singleColumnGrid : {}) }}>
            <div style={styles.card}>
              <h2 style={styles.cardTitle}>Post Notification</h2>
              <input
                placeholder="Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                style={styles.input}
              />
              <textarea
                rows="5"
                placeholder="Notification Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                style={styles.textarea}
              />
              <button onClick={addNotification} style={styles.primaryButton}>
                Post Notification
              </button>
            </div>

            <div style={styles.card}>
              <div style={{ ...styles.cardHeader, ...(isMobile ? styles.cardHeaderMobile : {}) }}>
                <div>
                  <h2 style={styles.cardTitle}>Posted Notifications</h2>
                  <p style={styles.cardSubtext}>{notifications.length} notifications posted</p>
                </div>
                <button onClick={fetchNotifications} style={styles.textButton}>
                  Refresh
                </button>
              </div>

              <div style={styles.notificationList}>
                {notifications.map((notification) => (
                  <article key={notification.id || `${notification.title}-${notification.message}`} style={styles.notificationItem}>
                    <div style={styles.notificationHeader}>
                      <h3 style={styles.notificationTitle}>{notification.title || "Untitled Notification"}</h3>
                      {(notification.created_at || notification.date) && (
                        <span style={styles.notificationDate}>
                          {notification.created_at || notification.date}
                        </span>
                      )}
                    </div>
                    <p style={styles.notificationMessage}>
                      {notification.message || notification.description || "No message available."}
                    </p>
                  </article>
                ))}

                {notifications.length === 0 && (
                  <div style={styles.emptyPanel}>
                    No notifications posted yet.
                  </div>
                )}
              </div>
            </div>
          </section>
        )}

            {activeTab === "facultyManagement" && (
                  <div style={styles.card}>
          <h2 style={styles.cardTitle}>Faculty Management</h2>

          <div style={styles.formGrid}>
            <input
              placeholder="Faculty Name"
              value={facultyName}
              onChange={(e) => setFacultyName(e.target.value)}
              style={styles.input}
            />

            <input
              placeholder="Designation"
              value={facultyDesignation}
              onChange={(e) => setFacultyDesignation(e.target.value)}
              style={styles.input}
            />

            <input
              placeholder="Qualification"
              value={facultyQualification}
              onChange={(e) => setFacultyQualification(e.target.value)}
              style={styles.input}
            />

            <input
              type="file"
              onChange={(e) => setFacultyImage(e.target.files[0])}
              style={styles.input}
            />
          </div>

          <button
            onClick={uploadFaculty}
            style={styles.primaryButton}
          >
            Add Faculty
          </button>
          
          <div style={styles.cardWide}>
  <h2 style={styles.cardTitle}>Faculty Records</h2>

  <div style={styles.tableWrap}>
    <table style={styles.table}>
      <thead>
        <tr>
          <th style={styles.th}>Photo</th>
          <th style={styles.th}>Name</th>
          <th style={styles.th}>Designation</th>
          <th style={styles.th}>Qualification</th>
          <th style={styles.th}>Action</th>
        </tr>
      </thead>

      <tbody>
        {faculty.map((f) => (
          <tr key={f.id}>
            <td style={styles.td}>
              <img
                src={`http://dietdubacherla.in/diet_backend/uploads/faculty/${f.image}`}
                alt={f.name}
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            </td>

            <td style={styles.td}>{f.name}</td>
            <td style={styles.td}>{f.designation}</td>
            <td style={styles.td}>{f.qualification}</td>

            <td style={styles.td}>
              <button
                onClick={() => deleteFaculty(f.id)}
                style={styles.deleteBtn}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}

        {faculty.length === 0 && (
          <tr>
            <td colSpan="5" style={styles.emptyCell}>
              No faculty records found.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</div>
        </div>
        
        )}

        {activeTab === "homeSlider" && (
          <section style={{ ...styles.moduleGrid, ...(isMobile ? styles.moduleGridMobile : {}) }}>
            <div style={styles.card}>
              <h2 style={styles.cardTitle}>Upload Home Slider Image</h2>
              <input
                placeholder="Slide title"
                value={homeSliderTitle}
                onChange={(e) => setHomeSliderTitle(e.target.value)}
                style={styles.input}
              />
              <input
                type="file"
                accept="image/png,image/jpeg,image/jpg,image/webp"
                onChange={(e) => setHomeSliderFile(e.target.files[0])}
                style={styles.input}
              />
              <button onClick={uploadHomeSlide} style={styles.primaryButton}>
                Upload Slide
              </button>
            </div>

            <div style={styles.cardWide}>
              <div style={{ ...styles.cardHeader, ...(isMobile ? styles.cardHeaderMobile : {}) }}>
                <div>
                  <h2 style={styles.cardTitle}>Homepage Slider Images</h2>
                  <p style={styles.cardSubtext}>{homeSlides.length} uploaded slides</p>
                </div>
                <button onClick={fetchHomeSlides} style={styles.textButton}>
                  Refresh
                </button>
              </div>

              <div style={styles.galleryScroll}>
                <div style={styles.galleryGrid}>
                  {homeSlides.map((slide) => (
                    <div key={slide.id} style={styles.galleryItem}>
                      <img
                        src={slide.image_url}
                        alt={slide.title}
                        style={styles.galleryImage}
                      />
                      <div style={styles.galleryMeta}>
                        <span>{slide.title}</span>
                        <button onClick={() => deleteHomeSlide(slide.id)} style={styles.iconDeleteBtn}>
                          Delete
                        </button>
                      </div>
                    </div>
                  ))}
                  {homeSlides.length === 0 && (
                    <p style={styles.mutedText}>
                      No homepage slider images uploaded yet. The home page will use default images.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </section>
        )}

        {activeTab === "gallery" && (
          <section style={{ ...styles.moduleGrid, ...(isMobile ? styles.moduleGridMobile : {}) }}>
            <div style={styles.card}>
              <h2 style={styles.cardTitle}>Upload Gallery Image</h2>
              <input
                placeholder="Title"
                value={galleryTitle}
                onChange={(e) => setGalleryTitle(e.target.value)}
                style={styles.input}
              />
              <input type="file" onChange={(e) => setGalleryFile(e.target.files[0])} style={styles.input} />
              <button onClick={uploadGallery} style={styles.primaryButton}>
                Upload Image
              </button>
            </div>

            <div style={styles.cardWide}>
              <div style={styles.cardHeader}>
                <h2 style={styles.cardTitle}>Gallery</h2>
                <button onClick={() => setExpandedGallery(!expandedGallery)} style={styles.textButton}>
                  {expandedGallery ? "Collapse" : "Expand"}
                </button>
              </div>
              <div style={{ ...styles.galleryScroll, maxHeight: expandedGallery ? "620px" : "300px" }}>
                <div style={styles.galleryGrid}>
                  {gallery.map((img) => (
                    <div key={img.id} style={styles.galleryItem}>
                      <img
                        src={`${API_BASE}/uploads/${img.image}`}
                        alt={img.title}
                        style={styles.galleryImage}
                      />
                      <div style={styles.galleryMeta}>
                        <span>{img.title}</span>
                        <button onClick={() => deleteGallery(img.id)} style={styles.iconDeleteBtn}>
                          Delete
                        </button>
                      </div>
                    </div>
                  ))}
                  {gallery.length === 0 && <p style={styles.mutedText}>No gallery images found.</p>}
                </div>
              </div>
            </div>
          </section>
        )}

        {activeTab === "downloads" && (
          <section style={{ ...styles.moduleGrid, ...(isMobile ? styles.moduleGridMobile : {}) }}>
            <div style={styles.card}>
              <h2 style={styles.cardTitle}>Upload Downloads</h2>
              <div style={styles.formGrid}>
                <input
                  placeholder="Title"
                  value={pdfTitle}
                  onChange={(e) => setPdfTitle(e.target.value)}
                  style={styles.input}
                />
                <select value={pdfCategory} onChange={(e) => setPdfCategory(e.target.value)} style={styles.input}>
                  <option value="students">Student Teachers</option>
                  <option value="teachers">In-Service Teachers</option>
                  <option value="notifications">Notifications</option>
                  <option value="press">Press Notes</option>
                </select>
                <select value={downloadType} onChange={(e) => setDownloadType(e.target.value)} style={styles.input}>
                  <option value="file">File</option>
                  <option value="link">Link</option>
                  <option value="text">News / Content</option>
                </select>
                {downloadType === "file" && (
                  <input
                    type="file"
                    onChange={(e) => setPdfFile(e.target.files[0])}
                    style={styles.input}
                  />
                )}
                {downloadType === "link" && (
                  <input
                    type="url"
                    placeholder="https://example.com"
                    value={downloadUrl}
                    onChange={(e) => setDownloadUrl(e.target.value)}
                    style={styles.input}
                  />
                )}
              </div>
              {(downloadType === "link" || downloadType === "text") && (
                <textarea
                  placeholder={downloadType === "link" ? "Optional description" : "Write news, context or content here"}
                  value={downloadText}
                  onChange={(e) => setDownloadText(e.target.value)}
                  style={{ ...styles.input, minHeight: "110px", resize: "vertical", marginTop: "10px" }}
                />
              )}
              <button onClick={uploadPDF} style={styles.primaryButton}>
                Upload Resource
              </button>
            </div>

            <div style={styles.cardWide}>
              <div style={{ ...styles.cardHeader, ...(isMobile ? styles.cardHeaderMobile : {}) }}>
                <div>
                  <h2 style={styles.cardTitle}>Uploaded Downloads</h2>
                  <p style={styles.cardSubtext}>{downloads.length} resources uploaded</p>
                </div>
                <button onClick={fetchDownloads} style={styles.textButton}>Refresh</button>
              </div>
              <div style={styles.tableWrap}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>Title</th>
                      <th style={styles.th}>Category</th>
                      <th style={styles.th}>Type</th>
                      <th style={styles.th}>Date</th>
                      <th style={styles.th}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {downloads.map((download) => (
                      <tr key={download.id}>
                        <td style={styles.td}>{download.title}</td>
                        <td style={styles.td}>{download.category}</td>
                        <td style={styles.td}>{download.source_type || "file"}</td>
                        <td style={styles.td}>{download.created_at}</td>
                        <td style={styles.td}>
                          {download.source_type === "text" ? (
                            <button onClick={() => alert(download.content_text || "No content")} style={styles.editBtn}>Read</button>
                          ) : (
                            <a href={download.file_url} target="_blank" rel="noreferrer" style={styles.editBtn}>View</a>
                          )}
                          <button onClick={() => deleteDownload(download.id)} style={styles.deleteBtn}>Delete</button>
                        </td>
                      </tr>
                    ))}
                    {downloads.length === 0 && (
                      <tr>
                        <td colSpan="5" style={styles.emptyCell}>No downloads uploaded yet.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        )}


        {activeTab === "timetable" && (
          <section style={{ ...styles.moduleGrid, ...(isMobile ? styles.moduleGridMobile : {}) }}>
            <div style={styles.card}>
              <h2 style={styles.cardTitle}>Upload Timetable</h2>
              <div style={styles.formGrid}>
                <input
                  placeholder="Timetable title"
                  value={timetableTitle}
                  onChange={(e) => setTimetableTitle(e.target.value)}
                  style={styles.input}
                />
                <select value={timetableAudience} onChange={(e) => setTimetableAudience(e.target.value)} style={styles.input}>
                  <option value="all">Students and Faculty</option>
                  <option value="student">Students Only</option>
                  <option value="faculty">Faculty Only</option>
                </select>
                <input
                  type="file"
                  accept="application/pdf,image/png,image/jpeg,image/jpg"
                  onChange={(e) => setTimetableFile(e.target.files[0])}
                  style={styles.input}
                />
              </div>
              <button onClick={uploadTimetable} style={styles.primaryButton}>Upload Timetable</button>
            </div>

            <div style={styles.cardWide}>
              <div style={{ ...styles.cardHeader, ...(isMobile ? styles.cardHeaderMobile : {}) }}>
                <div>
                  <h2 style={styles.cardTitle}>Uploaded Timetables</h2>
                  <p style={styles.cardSubtext}>{timetables.length} timetable files</p>
                </div>
                <button onClick={fetchTimetables} style={styles.textButton}>Refresh</button>
              </div>
              <div style={styles.tableWrap}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>Title</th>
                      <th style={styles.th}>Audience</th>
                      <th style={styles.th}>Date</th>
                      <th style={styles.th}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {timetables.map((item) => (
                      <tr key={item.id}>
                        <td style={styles.td}>{item.title}</td>
                        <td style={styles.td}>{item.audience}</td>
                        <td style={styles.td}>{item.created_at}</td>
                        <td style={styles.td}>
                          <a href={item.file_url} target="_blank" rel="noreferrer" style={styles.editBtn}>View</a>
                          <button onClick={() => deleteTimetable(item.id)} style={styles.deleteBtn}>Delete</button>
                        </td>
                      </tr>
                    ))}
                    {timetables.length === 0 && (
                      <tr>
                        <td colSpan="4" style={styles.emptyCell}>No timetables uploaded yet.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        )}

        {activeTab === "leaves" && (
          <section style={styles.card}>
            <div style={{ ...styles.cardHeader, ...(isMobile ? styles.cardHeaderMobile : {}) }}>
              <h2 style={styles.cardTitle}>Leave Requests</h2>
              <input
                type="text"
                placeholder="Search by student ID, reason, status or date"
                value={leaveSearch}
                onChange={(e) => setLeaveSearch(e.target.value)}
                style={styles.searchInput}
              />
            </div>
            <div style={styles.tableWrap}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Name</th>
                    {/* <th style={styles.th}>Role</th> */}
                    <th style={styles.th}>From</th>
                    <th style={styles.th}>To</th>
                    <th style={styles.th}>Days</th>
                    <th style={styles.th}>Reason</th>
                    <th style={styles.th}>Remaining</th>
                    <th style={styles.th}>Status</th>
                    <th style={styles.th}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredLeaves.map((leave) => (
                    <tr key={leave.id}>
                      <td style={styles.td}>{leave.college_id}</td>
                      {/* <td style={styles.td}>{leave.role}</td> */}
                      <td style={styles.td}>{leave.from_date}</td>
                      <td style={styles.td}>{leave.to_date}</td>
                      <td style={styles.td}>{leave.leave_days || 1}</td>
                      <td style={styles.td}>{leave.reason}</td>
                      <td style={styles.td}>{leave.remaining_leaves ?? 20}</td>
                      <td style={styles.td}>
                        <StatusPill status={leave.status} />
                      </td>
                      <td style={styles.td}>
                        <button
                          style={styles.approveBtn}
                          onClick={() => updateLeaveStatus(leave.id, "Approved")}
                        >
                          Approve
                        </button>
                        <button
                          style={styles.deleteBtn}
                          onClick={() => updateLeaveStatus(leave.id, "Rejected")}
                        >
                          Reject
                        </button>
                      </td>
                    </tr>
                  ))}
                  {filteredLeaves.length === 0 && (
                    <tr>
                      <td colSpan="9" style={styles.emptyCell}>
                        No matching leave requests found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </section>
        )}
      </main>

      {activeProfile && (
        <div style={styles.modalBackdrop} onClick={() => setActiveProfile(null)}>
          <div style={styles.profileModal} onClick={(event) => event.stopPropagation()}>
            <div style={styles.cardHeader}>
              <h2 style={styles.cardTitle}>Student Profile</h2>
              <button style={styles.textButton} onClick={() => setActiveProfile(null)}>Close</button>
            </div>
            <div style={styles.profileModalHeader}>
              {activeProfile.photo_url && <img src={activeProfile.photo_url} alt={activeProfile.name} style={styles.profilePhotoLarge} />}
              <div>
                <h3 style={styles.profileName}>{activeProfile.surname} {activeProfile.name}</h3>
                <p style={styles.cardSubtext}>{activeProfile.deecet_id} | Admission No. {activeProfile.admission_no || "-"}</p>
              </div>
            </div>
            <div style={styles.profileDetailGrid}>
              {[
                ["Batch", activeProfile.batch], ["Medium", activeProfile.medium], ["Optional Subject", activeProfile.optional_subject],
                ["DOB", activeProfile.dob], ["Aadhar", activeProfile.aadhar], ["Mobile", activeProfile.mobile],
                ["Caste", activeProfile.caste], ["Father", activeProfile.father], ["Father Mobile", activeProfile.father_mobile],
                ["Mother", activeProfile.mother], ["Mother Mobile", activeProfile.mother_mobile], ["Village", activeProfile.village],
                ["Mandal", activeProfile.mandal], ["New District", activeProfile.district],
              ].map(([label, value]) => (
                <div key={label} style={styles.profileDetailItem}>
                  <span>{label}</span>
                  <strong>{value || "-"}</strong>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function StatCard({ label, value, tone }) {
  return (
    <div style={styles.statCard}>
      <span style={{ ...styles.statAccent, background: tone }} />
      <p style={styles.statLabel}>{label}</p>
      <h3 style={styles.statValue}>{value}</h3>
    </div>
  );
}

function StatusPill({ status }) {
  const tone =
    status === "Approved"
      ? styles.statusApproved
      : status === "Rejected"
      ? styles.statusRejected
      : styles.statusPending;

  return <span style={{ ...styles.statusPill, ...tone }}>{status}</span>;
}

function DataTable({ columns, rows, emptyText }) {
  return (
    <div style={styles.tableWrap}>
      <table style={styles.table}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column} style={styles.th}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td key={cellIndex} style={styles.td}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
          {rows.length === 0 && (
            <tr>
              <td colSpan={columns.length} style={styles.emptyCell}>
                {emptyText}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

const styles = {
  appShell: {
    minHeight: "100vh",
    display: "flex",
    background: "#f3f4f6",
    color: "#1f2937",
    fontFamily: "Inter, Arial, sans-serif",
  },
  appShellMobile: {
    display: "block",
  },
  sidebar: {
    width: "270px",
    background: "#7f1d1d",
    color: "white",
    padding: "22px 16px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    position: "sticky",
    top: 0,
    height: "100vh",
  },
  sidebarMobile: {
    width: "100%",
    height: "auto",
    boxSizing: "border-box",
    padding: "14px 12px",
    gap: "12px",
    position: "sticky",
    zIndex: 10,
  },
  brandBlock: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "4px 8px 16px",
    borderBottom: "1px solid rgba(255,255,255,0.18)",
  },
  brandBlockMobile: {
    padding: "0 4px 10px",
  },
  brandMark: {
    width: "42px",
    height: "42px",
    borderRadius: "8px",
    background: "white",
    color: "#7f1d1d",
    display: "grid",
    placeItems: "center",
    fontWeight: "800",
    fontSize: "22px",
  },
  brandTitle: {
    margin: 0,
    fontSize: "20px",
    letterSpacing: "0",
  },
  brandSubtext: {
    margin: "4px 0 0",
    color: "#fecaca",
    fontSize: "13px",
  },
  navList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  navListMobile: {
    flexDirection: "row",
    overflowX: "auto",
    paddingBottom: "4px",
  },
  navButton: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    width: "100%",
    padding: "12px",
    border: "none",
    borderRadius: "8px",
    background: "transparent",
    color: "#fee2e2",
    cursor: "pointer",
    fontWeight: "700",
    textAlign: "left",
  },
  navButtonMobile: {
    flex: "0 0 auto",
    width: "auto",
    minWidth: "112px",
    justifyContent: "center",
    padding: "10px",
    fontSize: "13px",
  },
  navButtonActive: {
    background: "white",
    color: "#7f1d1d",
    boxShadow: "0 8px 18px rgba(0,0,0,0.16)",
  },
  navIcon: {
    width: "28px",
    height: "28px",
    borderRadius: "6px",
    display: "grid",
    placeItems: "center",
    background: "rgba(255,255,255,0.14)",
    fontSize: "11px",
    fontWeight: "800",
  },
  navLabel: {
    whiteSpace: "nowrap",
  },
  logoutButton: {
    marginTop: "auto",
    background: "#991b1b",
    color: "white",
    border: "1px solid rgba(255,255,255,0.2)",
    padding: "12px",
    borderRadius: "8px",
    fontWeight: "800",
    cursor: "pointer",
  },
  logoutButtonMobile: {
    display: "none",
  },
  mainPanel: {
    flex: 1,
    padding: "28px",
    overflowX: "hidden",
  },
  mainPanelMobile: {
    padding: "14px",
  },
  topBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    marginBottom: "24px",
    background: "white",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "22px",
    boxShadow: "0 1px 2px rgba(15,23,42,0.06)",
  },
  topBarMobile: {
    display: "block",
    padding: "16px",
    marginBottom: "14px",
  },
  eyebrow: {
    margin: "0 0 6px",
    color: "#991b1b",
    fontSize: "12px",
    fontWeight: "800",
    textTransform: "uppercase",
  },
  pageTitle: {
    margin: 0,
    color: "#111827",
    fontSize: "28px",
  },
  pageTitleMobile: {
    fontSize: "23px",
  },
  pageDescription: {
    margin: "6px 0 0",
    color: "#6b7280",
    fontSize: "14px",
  },
  secondaryLogout: {
    background: "#111827",
    color: "white",
    border: "none",
    padding: "11px 16px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "800",
  },
  hideOnMobile: {
    display: "none",
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",
    gap: "16px",
    marginBottom: "20px",
  },
  statsGridMobile: {
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "10px",
    marginBottom: "14px",
  },
  statCard: {
    background: "white",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "20px",
    position: "relative",
    overflow: "hidden",
    boxShadow: "0 1px 2px rgba(15,23,42,0.05)",
  },
  statAccent: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "4px",
  },
  statLabel: {
    margin: 0,
    color: "#6b7280",
    fontWeight: "700",
    fontSize: "14px",
  },
  statValue: {
    margin: "12px 0 0",
    color: "#111827",
    fontSize: "34px",
  },
  twoColumn: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: "20px",
  },
  singleColumnGrid: {
    gridTemplateColumns: "1fr",
    gap: "14px",
  },
  moduleGrid: {
    display: "grid",
    gridTemplateColumns: "minmax(280px, 380px) minmax(0, 1fr)",
    gap: "20px",
    alignItems: "start",
  },
  moduleGridMobile: {
    gridTemplateColumns: "1fr",
    gap: "14px",
  },
  card: {
    background: "white",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "20px",
    boxShadow: "0 1px 2px rgba(15,23,42,0.05)",
  },
  cardWide: {
    background: "white",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "20px",
    boxShadow: "0 1px 2px rgba(15,23,42,0.05)",
    overflow: "hidden",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
    marginBottom: "16px",
  },
  cardHeaderMobile: {
    display: "grid",
    alignItems: "stretch",
    gap: "10px",
  },
  cardTitle: {
    margin: "0 0 16px",
    color: "#111827",
    fontSize: "20px",
  },
  cardSubtext: {
    margin: "4px 0 0",
    color: "#6b7280",
    fontSize: "13px",
    fontWeight: "700",
  },
  formGrid: {
    display: "grid",
    gap: "12px",
    marginBottom: "14px",
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
    padding: "11px 12px",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    fontSize: "14px",
    outlineColor: "#991b1b",
  },
  textarea: {
    width: "100%",
    boxSizing: "border-box",
    padding: "11px 12px",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    fontSize: "14px",
    resize: "vertical",
    outlineColor: "#991b1b",
    marginBottom: "12px",
  },
  searchInput: {
    width: "min(360px, 100%)",
    boxSizing: "border-box",
    padding: "10px 12px",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    outlineColor: "#991b1b",
  },
  primaryButton: {
    background: "#991b1b",
    color: "white",
    border: "none",
    padding: "11px 18px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "800",
  },
  textButton: {
    background: "#fef2f2",
    color: "#991b1b",
    border: "1px solid #fecaca",
    padding: "9px 12px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "800",
    whiteSpace: "nowrap",
  },
  quickActions: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    gap: "12px",
  },
  quickActionButton: {
    minHeight: "52px",
    background: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "800",
    color: "#374151",
  },
  tableWrap: {
    width: "100%",
    maxHeight: "430px",
    overflow: "auto",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "720px",
  },
  th: {
    padding: "12px",
    textAlign: "left",
    background: "#f9fafb",
    color: "#374151",
    borderBottom: "1px solid #e5e7eb",
    fontSize: "13px",
    fontWeight: "800",
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  td: {
    padding: "12px",
    borderBottom: "1px solid #eef2f7",
    color: "#374151",
    fontSize: "14px",
    verticalAlign: "middle",
  },
  emptyCell: {
    padding: "22px",
    textAlign: "center",
    color: "#6b7280",
    borderBottom: "1px solid #eef2f7",
  },
  rolePill: {
    display: "inline-flex",
    padding: "5px 9px",
    borderRadius: "999px",
    background: "#eef2ff",
    color: "#3730a3",
    fontWeight: "800",
    fontSize: "12px",
    textTransform: "capitalize",
  },
  statusPill: {
    display: "inline-flex",
    padding: "5px 9px",
    borderRadius: "999px",
    fontWeight: "800",
    fontSize: "12px",
  },
  statusApproved: {
    background: "#dcfce7",
    color: "#166534",
  },
  statusRejected: {
    background: "#fee2e2",
    color: "#991b1b",
  },
  profileThumb: { width: "46px", height: "46px", borderRadius: "6px", objectFit: "cover" },
  modalBackdrop: { position: "fixed", inset: 0, background: "rgba(17,24,39,0.45)", display: "grid", placeItems: "center", padding: "16px", zIndex: 20 },
  profileModal: { width: "min(860px, 100%)", maxHeight: "88vh", overflowY: "auto", background: "#fff", borderRadius: "8px", padding: "18px", boxShadow: "0 18px 40px rgba(0,0,0,0.22)" },
  profileModalHeader: { display: "flex", alignItems: "center", gap: "14px", marginBottom: "14px" },
  profilePhotoLarge: { width: "86px", height: "86px", borderRadius: "8px", objectFit: "cover", border: "1px solid #e5e7eb" },
  profileName: { margin: 0, color: "#111827" },
  profileDetailGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "10px" },
  profileDetailItem: { display: "grid", gap: "4px", padding: "10px", border: "1px solid #e5e7eb", borderRadius: "6px", background: "#f9fafb" },
  statusPending: {
    background: "#fef3c7",
    color: "#92400e",
  },
  editBtn: {
    background: "#166534",
    color: "white",
    border: "none",
    padding: "8px 11px",
    marginRight: "8px",
    borderRadius: "7px",
    cursor: "pointer",
    fontWeight: "700",
  },
  approveBtn: {
    background: "#166534",
    color: "white",
    border: "none",
    padding: "8px 11px",
    marginRight: "8px",
    borderRadius: "7px",
    cursor: "pointer",
    fontWeight: "700",
  },
  deleteBtn: {
    background: "#991b1b",
    color: "white",
    border: "none",
    padding: "8px 11px",
    borderRadius: "7px",
    cursor: "pointer",
    fontWeight: "700",
  },
  galleryScroll: {
    maxHeight: "430px",
    overflowY: "auto",
    transition: "max-height 0.2s ease",
  },
  galleryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))",
    gap: "14px",
  },
  galleryItem: {
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    overflow: "hidden",
    background: "#f9fafb",
  },
  galleryImage: {
    width: "100%",
    height: "150px",
    objectFit: "cover",
    display: "block",
  },
  galleryMeta: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    padding: "10px",
    fontSize: "13px",
    fontWeight: "700",
  },
  iconDeleteBtn: {
    background: "#fee2e2",
    color: "#991b1b",
    border: "1px solid #fecaca",
    borderRadius: "7px",
    padding: "6px 8px",
    cursor: "pointer",
    fontWeight: "800",
  },
  mutedText: {
    margin: 0,
    color: "#6b7280",
  },
  notificationList: {
    display: "grid",
    gap: "12px",
    maxHeight: "520px",
    overflowY: "auto",
    paddingRight: "4px",
  },
  notificationItem: {
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "14px",
    background: "#f9fafb",
  },
  notificationHeader: {
    display: "flex",
    justifyContent: "space-between",
    gap: "12px",
    alignItems: "flex-start",
    marginBottom: "8px",
  },
  notificationTitle: {
    margin: 0,
    color: "#111827",
    fontSize: "15px",
    lineHeight: 1.35,
  },
  notificationDate: {
    flex: "0 0 auto",
    color: "#6b7280",
    fontSize: "12px",
    fontWeight: "700",
  },
  notificationMessage: {
    margin: 0,
    color: "#4b5563",
    fontSize: "14px",
    lineHeight: 1.5,
    whiteSpace: "pre-wrap",
  },
  emptyPanel: {
    padding: "22px",
    textAlign: "center",
    color: "#6b7280",
    border: "1px dashed #d1d5db",
    borderRadius: "8px",
    background: "#f9fafb",
    fontWeight: "700",
  },
  summaryBlock: {
    minHeight: "150px",
    display: "grid",
    placeItems: "center",
    textAlign: "center",
    border: "1px dashed #d1d5db",
    borderRadius: "8px",
    background: "#f9fafb",
  },
  summaryNumber: {
    display: "block",
    fontSize: "42px",
    color: "#991b1b",
  },
  summaryLabel: {
    display: "block",
    color: "#6b7280",
    fontWeight: "700",
  },
};

